import React from 'react';
import { noop } from 'lodash/fp';
import Textarea from '../../../../../common/components/Textarea';
import { JSON_ICON_TOOLTIP_TEXT } from '../../constants/constants';
import messengerAdsJSONHelpImage from 'assets/ads-json-help-new.png';
import { QuestionCircleIcon } from '@mm/icons';
import classnames from 'classnames';

type Props = {
  code: string;
  usedInSlideout?: boolean;
};

export const JSONCodeTextArea = ({ code, usedInSlideout }: Props) => (
  <div className="ad-detail__inputs-container">
    <div
      className={classnames('ad-detail__input-container', {
        'ad-detail__input-container-slideout': usedInSlideout,
      })}
    >
      <div className="ad-detail__field-title">Messenger Setup JSON</div>
      <div>
        <div className="ad-detail__subtext-grey">
          {JSON_ICON_TOOLTIP_TEXT}

          <QuestionCircleIcon
            color="var(--color-gray-8)"
            className="ad-detail__subtext-icon"
            onClick={() => window.open(messengerAdsJSONHelpImage, '_blank')}
          />
        </div>
      </div>
      <div className="ad-detail__json-input-container">
        <Textarea
          className="ad-detail__input messenger-ad-detail__json-textarea"
          value={code}
          placeholder="JSON Code of your Ad"
          onChange={noop}
        />
      </div>
    </div>
  </div>
);
